export default __webpack_public_path__ + "static/media/iconProducts.62d5f3f2.svg";